import React from 'react';
import Grid from '@mui/material/Grid';
import Logo from '../assets/image 2.png';
import Fb from '../assets/fb.png';
import Box from '@mui/material/Box';
import Insta from '../assets/insta.png';
import Tweet from '../assets/tweet.png';
import { Link } from 'react-router-dom';
function Footer() {
    return (
        <div className="footer">
            <Grid container spacing={4}>
                <Grid item md={3.75}>
                    <div>
                        <div className="center">
                            <img className="footlogo" src={Logo} alt="Logo" />
                            <p className="footabo">We are the one platform that guides, trains, and serves the needs of aspirants and employers. PPLACD is targeting unemployment by creating a skilled workforce relevant to the industry.
                            </p>
                        </div>
                    </div>
                </Grid>
                <Grid className="justcenter" item md={1.5}>
                    <div className="footerlist">
                        <p className="quickfoot">Quick Links</p>
                        <span className="footerlist">
                            <Link className="footerlink" to=''>Home</Link>
                            <Link className="footerlink" to=''>About</Link>
                            <Link className="footerlink" to=''>Blogs</Link>
                            <Link className="footerlink" to=''>Testimonials</Link>
                            <Link className="footerlink" to=''>Contact Us</Link>
                        </span>
                    </div>
                </Grid>
                <Grid className="justcenter" item md={1.5}>
                    <div className="footerlist">
                        <p className="quickfoot">Helpful Resources</p>
                        <span className="footerlist">
                            <Link className="footerlink" to=''>FAQs</Link>
                            <Link className="footerlink" to='/terms-condition'>Terms & Conditions</Link>
                            <Link className="footerlink" to='/privacy-policy'>Privacy Policy</Link>
                            <Link className="footerlink" to='/refund-policy'>Refund Policy</Link>
                            <Link className="footerlink" to=''>Disclaimer</Link>
                        </span>
                    </div>
                </Grid>
                <Grid className="justcenter" item md={1.5}>
                    <div className="footerlist">
                        <p className="quickfoot">Sign Up </p>
                        <span className="footerlist">
                            <Link className="footerlink" to=''>Candidate</Link>
                            <Link className="footerlink" to=''>Coach</Link>
                            <Link className="footerlink" to=''>Employer</Link>
                        </span>
                    </div>
                </Grid>
                <Grid item md={3.75}>
                    <div className="newsign">
                        <div>
                            <p className="footabo">Share your mail to stay updated with PPLACD. We are happy to keep you ahead of the rest.
                            </p>
                            <Box className="input-container">
                                <input required="" placeholder="Enter Your Email " type="email"/>
                                    <button className="btn" type="button">
                                        Subscribe
                                    </button>
                            </Box>

                        </div>
                    </div>
                </Grid>
            </Grid>
            <hr className="foothr"></hr>
            <div className="footlast">
                <p className="copyfoot">Copyright © 2022 by PPLACD All Rights Reserved.</p>
                <div className="flexfoot">
                    <img className="footsoc" src={Tweet} alt="Socailmedia" />
                    <img className="footsoc" src={Fb} alt="Socailmedia" />
                    <img className="footsoc" src={Insta} alt="Socailmedia" />
                </div>
            </div>
        </div>
    );
}

export default Footer;
